"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInputTitle = exports.SearchAreaWrapper = exports.ShimmerText = exports.Shimmer = exports.Title = exports.NoResultsContainer = exports.Item = exports.ItemList = exports.ShowMoreButtonContainer = exports.Col = exports.ColContainer = exports.ColContainerHeader = exports.Container = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.Container = (0, styled_1.default)('div') `
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_large')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  border-radius: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.ColContainerHeader = (0, styled_1.default)('div') `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    flex-wrap: nowrap;
  }
`;
exports.ColContainer = (0, styled_1.default)('div') `
  display: flex;
  flex-wrap: wrap;
  position: relative;
  background: transparent;
  @media (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    flex-wrap: nowrap;
  }
  &.contracted {
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 30px;
      pointer-events: none;
      background: transparent;
      transition: background 1s;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        ${(0, ui_theme_1.fromTheme)('color_background')} 100%
      );
    }
  }
`;
exports.Col = (0, styled_1.default)('div') `
  flex-basis: 100%;
  :not(:last-child) {
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  }
`;
exports.ShowMoreButtonContainer = (0, styled_1.default)('div') `
  text-align: center;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  button {
    padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  }

  @media print {
    display: none;
  }
`;
exports.ItemList = (0, styled_1.default)('ul') `
  padding: 0;
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0 0 0;
  @media (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    margin: ${(0, ui_theme_1.fromTheme)('spacing_large')} 0 0 0;
  }
`;
exports.Item = (0, styled_1.default)('li') `
  list-style-type: none;
  box-sizing: border-box;
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  :not(:last-child) {
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.NoResultsContainer = (0, styled_1.default)('div') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_large')} 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};

  button {
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
    margin-left: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }
`;
exports.Title = (0, styled_1.default)('h2') `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  @media (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    margin-bottom: 0;
  }
`;
exports.Shimmer = (0, styled_1.default)(`div`) `
  border-radius: 2px;
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  background: linear-gradient(
    to right,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 10%,
    ${(0, ui_theme_1.fromTheme)('color_background_disabled_form_input')} 18%,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 33%
  );
  background-size: 1000px 640px;
  height: 100%;
  position: relative;
`;
exports.ShimmerText = (0, styled_1.default)(exports.Shimmer) `
  height: ${(props) => props.height || (0, ui_theme_1.fromTheme)('font_size')};
`;
exports.SearchAreaWrapper = (0, styled_1.default)('div') `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.SearchInputTitle = (0, styled_1.default)('strong') `
  display: block;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
`;
//# sourceMappingURL=styles.js.map